import * as React from 'react';
import { Loading, Row, Col, CheckBox, Input, Divider } from 'sha-el-design';
import { GraphqlQuery } from 'requestapijs';
import { AreaNodeConnection, TownNode, AreaNode } from '../../../schema';
import { areaDropdownQuery } from './constants';
import { FaSearch } from 'react-icons/fa';
import '../Common/listPageStyles';
import * as moment from 'moment';

export class AreaDropdown extends React.Component<Props, State> {
  static defaultProps = {
    extrafields: [],
  };

  constructor(props) {
    super(props);

    this.state = {
      searchQuery: '',
    };
  }

  onAreaSelect = (selected: boolean, area: AreaNode) => {
    const { areas, onAreaSelect } = this.props;

    if (selected) {
      const newTowns = [...areas, area];
      return onAreaSelect(newTowns);
    }

    const updatedTowns = [...areas];
    updatedTowns.splice(updatedTowns.findIndex((v) => v.id === area.id), 1);
    onAreaSelect(updatedTowns);
  }

  isAreaSelected = (area: AreaNode) => {
    const { areas } = this.props;
    if (areas.find((v) => v.id === area.id)) {
      return true;
    }
    return false;
  }

  render() {
    return (
      <GraphqlQuery
        queryString={areaDropdownQuery}
        variables={{
          after: '',
          selectedTown: this.props.selectedTown.id,
          name: this.state.searchQuery,
        }}
        render={(response: { allAreas: AreaNodeConnection }, error, loading) => {
          if (error) {
            return <h3>Something went wrong</h3>;
          }
          return (
            <Loading
              isLoading={loading || !response}
              render={() => (
                <div>
                  <Input
                    placeholder='Search Area'
                    value={this.state.searchQuery}
                    onChange={(e) => this.setState({ searchQuery: e.target.value })}
                    after={
                      <FaSearch />
                    }
                  />
                  <Divider />
                  {response.allAreas && response.allAreas.edges.filter((area) => {
                    if (!this.props.toShowWithZeroRetailer) {
                      return ((area.node.retailerCount !== 0) && !area.node.assigned);
                    }
                    return !area.node.assigned;
                  }).map((value) => (
                    // Was: a bare CheckBox with no label in one Col and the
                    // area name in another, so clicking the NAME did nothing --
                    // only the ~16px box was a hit target. And the counts read
                    // "No Of Retailers:42" because JSX strips the newline after
                    // the colon. Same pill treatment as the town rows above.
                    <div className='cs-wiz__area' key={value.node.id}>
                      <CheckBox
                        onChange={(e) => this.onAreaSelect(e.target.checked, value.node)}
                        checked={this.isAreaSelected(value.node)}
                        type='checkbox'
                        label={value.node.name}
                      />
                      <span className='cs-wiz__town-meta'>
                        <span
                          className={
                            'cs-wiz__pill ' +
                            (value.node.retailerCount ? 'cs-wiz__pill--count' : 'cs-wiz__pill--empty')
                          }
                        >
                          {value.node.retailerCount} {value.node.retailerCount === 1 ? 'retailer' : 'retailers'}
                        </span>
                        <span className='cs-wiz__pill'>
                          {value.node.lastCallDate
                            ? `Last call ${moment(value.node.lastCallDate).format('DD MMM YYYY')}`
                            : 'Never called'}
                        </span>
                      </span>
                    </div>
                  ))}
                </div>
              )}
            />
          );
        }}
      />
    );
  }
}

interface Props {
  selectedTown: TownNode;
  onAreaSelect: (areas: AreaNode[]) => void;
  areas: AreaNode[];
  toShowWithZeroRetailer: boolean;
}

interface State {
  searchQuery: string;
}
